module.exports = __webpack_public_path__ + "static/media/sadCat.da6c42e7.png";